export const state = () => ({
  sections: [],
  monthlySections: [],
  section: null,
  monthlyIntention: null,
  loading: false
})
export const mutations = {
  LOADSECTIONS (state, payload) {
    state.sections = payload
  },
  LOADMONTHLYSECTION (state, payload) {
    state.monthlySections = payload
  },
  SETLOADING (state, payload) {
    state.loading = payload
  },
  SETSECTION (state, payload) {
    state.section = payload
  },
  SETMONTHLYINTENTION (state, payload) {
    state.monthlyIntention = payload
  }
}
export const actions = {
  async fetch ({ commit }, payload) {
    if (payload !== null && payload !== undefined) {
      commit('SETLOADING', true)
      return await this.$axios
        .$get('hero-sections', {
          params: {
            search_text: payload.search_text ? payload.search_text : null,
            page: payload.page,
            per_page: payload.per_page,
            sectionBy: payload.sectionBy,
            'filter[trashed]': payload.trashed,
            'filter[customer_id]': payload.customer_id
              ? payload.customer_id
              : null,
            'filter[status]': payload.status,
            'filter[payment_method]': payload.payment_method,
            'filter[date_range]': payload.date_range,
            'filter[nodhom_status]': payload.nodhom_status,
            'filter[subscriptions_transferred]':
              payload.subscriptions_transferred
          }
        })
        .then((response) => {
          commit('SETLOADING', false)

          commit('LOADSECTIONS', response.data)
        })
        .catch(() => {
          commit('SETLOADING', false)
        })
    } else {
      commit('SETLOADING', true)

      return this.$axios
        .$get('hero-sections', {
          params: {
            search_text: '',
            page: 1,
            per_page: 10,
            sectionBy: 'created_at'
          }
        })
        .then((response) => {
          commit('SETLOADING', false)
          commit('LOADSECTIONS', response.data)
        })
        .catch(() => {
          commit('SETLOADING', false)
        })
    }
  },
  async fetchMonthlyIntentions ({ commit }, payload) {
    if (payload !== null && payload !== undefined) {
      commit('SETLOADING', true)
      return await this.$axios
        .$get('monthly-event-sections', {
          params: {
            search_text: payload.search_text ? payload.search_text : null,
            page: payload.page,
            per_page: payload.per_page,
            sectionBy: payload.sectionBy,
            'filter[trashed]': payload.trashed,
            'filter[customer_id]': payload.customer_id
              ? payload.customer_id
              : null,
            'filter[status]': payload.status,
            'filter[payment_method]': payload.payment_method,
            'filter[date_range]': payload.date_range,
            'filter[nodhom_status]': payload.nodhom_status,
            'filter[subscriptions_transferred]':
              payload.subscriptions_transferred
          }
        })
        .then((response) => {
          commit('SETLOADING', false)

          commit('LOADMONTHLYSECTION', response.data)
        })
        .catch(() => {
          commit('SETLOADING', false)
        })
    } else {
      commit('SETLOADING', true)

      return this.$axios
        .$get('monthly-event-sections', {
          params: {
            search_text: '',
            page: 1,
            per_page: 10,
            sectionBy: 'created_at'
          }
        })
        .then((response) => {
          commit('SETLOADING', false)
          commit('LOADMONTHLYSECTION', response.data)
        })
        .catch(() => {
          commit('SETLOADING', false)
        })
    }
  },

  async createSection ({ commit }, payload) {
    commit('SETLOADING', true)

    const response = await this.$axios.$post('hero-sections', payload)
    commit('SETLOADING', false)
    return response
  },
  async createMonthlyIntention ({ commit }, payload) {
    commit('SETLOADING', true)

    const response = await this.$axios.$post('monthly-event-sections', payload)
    commit('SETLOADING', false)
    return response
  },
  async filter ({ commit }, payload) {
    if (payload !== null && payload !== undefined) {
      commit('SETLOADING', true)
      const response = await this.$axios.$post('hero-sections', payload)
      commit('SETLOADING', false)
      commit('LOADsectionS', response.data)
      return response
    }
  },
  async getSection ({ commit }, payload) {
    commit('SETLOADING', true)

    try {
      const response = await this.$axios.$get(`hero-sections/${payload}`)
      commit('SETSECTION', response.data)
      return response
    } finally {
      commit('SETLOADING', false)
    }
  },
  async getMonthlyIntention ({ commit }, payload) {
    commit('SETLOADING', true)

    try {
      const response = await this.$axios.$get(`monthly-event-sections/${payload}`)
      commit('SETMONTHLYINTENTION', response.data)
      return response
    } finally {
      commit('SETLOADING', false)
    }
  },
  async updateMonthlyIntention ({ commit, dispatch }, payload) {
    commit('SETLOADING', true)

    const response = await this.$axios.$post(
      `monthly-event-sections/${payload.id}`,
      payload.form_data
    )
    commit('SETLOADING', false)

    return response
  },
  async updateSection ({ commit, dispatch }, payload) {
    commit('SETLOADING', true)

    const response = await this.$axios.$post(
      `hero-sections/${payload.id}`,
      payload.form_data
    )
    commit('SETLOADING', false)

    return response
  },
  deleteSection ({ commit }, payload) {
    return this.$axios.$delete('hero-sections', {
      data: {
        ids: payload
      }
    })
  },
  deleteMonthlyIntention ({ commit }, payload) {
    return this.$axios.$delete('monthly-event-sections', {
      data: {
        ids: payload
      }
    })
  }
}
